<template>
  <v-container fluid>
    <h2>homepage and widgets</h2>
  </v-container>
</template>

<script>
import HelloWorld from '../components/HelloWorld';

export default {
  components: {

  },
};
</script>
